import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { TranslateComponentModalService } from './translate-component-modal.service';
import { ToasterService } from 'src/app/toaster.service';
import mixpanel from 'mixpanel-browser';
import { I18n } from 'src/app/i18n.service';
import { AppState } from 'src/app/app.service';

@Component({
  selector: 'app-translate-component-modal',
  templateUrl: './translate-component-modal.component.html',
  styleUrls: ['./translate-component-modal.component.scss'],
})
export class TranslateComponentModalComponent implements OnInit {

 @Input() languages: [string, string][] = [];
  @Input() pathLanguage: [string, string] | null = null;
  /**
   * A language to pin above the Cycle's, for a caller that holds a choice of its own — the practice
   * bot pins the language the learner picked for the coach, with the Cycle's underneath it.
   *
   * Null for the callers that have no such choice, which leaves the list exactly as it was. A row
   * equal to `pathLanguage` is rendered once, not twice.
   */
  @Input() chosenLanguage: [string, string] | null = null;
  /**
   * Whether the list offers "None".
   *
   * True where it means "do not translate", which is what that row is for. False for the practice
   * bot: blank there means "reuse whatever is saved" — never "clear" — so a learner who once chose
   * Hindi and then picks None gets Hindi again, not the Cycle's language the row seems to promise.
   * The Cycle's own language is pinned as a row of its own, which says that properly.
   */
  @Input() allowNone = true;
  @Input() title: string = 'Translate all comments';
  /**
   * What to open with, for a caller whose language is not the app's translate setting — the
   * practice bot picks the language its coach speaks, which starts as the Cycle's own.
   *
   * Absent, this falls back to the translate setting, which is what every other caller wants.
   */
  @Input() initialLanguage: string | null = null;
  /**
   * Whether Done saves the choice as the learner's app-wide translate language.
   *
   * True for the header and the question screen, which is what that setting is for: it decides the
   * language community posts and comments are translated into. The practice bot picks the language
   * its coach speaks — a different thing entirely — and must not move it.
   */
  @Input() persistAsAppLanguage = true;
  selectedLang: string = 'none';

  constructor(private modalCtrl: ModalController, private translateModalService: TranslateComponentModalService,
    private toasterService: ToasterService, public i18n: I18n, private appState:AppState
  ) {}
  
  ngOnInit() {
    if (this.initialLanguage) {
      this.selectedLang = this.initialLanguage;
      return;
    }
    this.selectedLang =this.appState.get('selectedLanguage')?this.appState.get('selectedLanguage'):'none'
  }
  dismiss() {
    mixpanel.track("User closed the modal by clicking on close before saving language");
    this.modalCtrl.dismiss();
  }

  confirm() {
    if (!this.persistAsAppLanguage) {
      // The caller keeps this language to practice bot itself. Nothing is saved and nothing in app state moves —
      // the answer is the whole of it.
      this.modalCtrl.dismiss(this.selectedLang);
      return;
    }
    if (this.selectedLang === this.appState.get('selectedLanguage') || (this.selectedLang === 'none' && !this.appState.get('selectedLanguage'))) {
      mixpanel.track("User selected the same language as before and closed the modal by clicking on done", { Language: this.selectedLang });
      // Unchanged, for a caller whose language this IS: nothing to tell it. The callers that keep
      // their own language never reach here — see the guard at the top.
      this.modalCtrl.dismiss();
    }
    else {
      this.translateModalService.saveTranslateLang(this.selectedLang).subscribe((res) => {
        this.appState.set("selectedLanguage", res?.user_language);
        let updateUser = this.appState.get('currentUser')
        updateUser.userLanguage = res?.user_language;
        this.appState.set("currentUser", updateUser);
        mixpanel.track("user selected language stored successfully after clicking on done", { Language: res?.user_language, selectedLang: this.selectedLang })
        this.modalCtrl.dismiss(this.selectedLang);
      }, (err) => {
        mixpanel.track("Error while storing language", { error: err })
        this.toasterService.error(this.i18n.t("Error while saving language, pls try again"))
      }
      )
    }
  }
}
